import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Styles } from "axl-reactjs-ui";
import ShipmentList from "../ShipmentList";
import ShipmentsStats from "../ShipmentsStats";
import DispatchSearchFilter from "../DispatchSearchFilter";
import ShipmentDetail from "../ShipmentDetail/index";
import DeliveryMapContainer from "../DeliveryMapContainer/index";

import styles, { MainContainer, MiddlePanel, RightPanel } from "./styles";
import {CircularProgress} from "@material-ui/core";
import WSShipmentModifier from "./WSShipmentModifier";

@inject("deliveryStore")
@observer
class ShipmentListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
    };
    this.onCollapse = this.onCollapse.bind(this);
  }

  onCollapse() {
    this.setState({ collapse: !this.state.collapse });
  }

  // onSelectShipment(shipment) {
  //     const { deliveryStore } = this.props
  //     const { regions, start } = deliveryStore
  //     let day = moment(start).format('YYYY-MM-DD');
  //     let region = regions.length > 0 ? regions[0] : 'all';
  //     this.props.history.push(`/deliveries/${day}/${region}`)
  //     deliveryStore.selectShipment(shipment);
  // }

  render() {
    const { collapse } = this.state;
    const { isBlur } = this.props;

    return (
      <Fragment>
        <div
          style={{
            ...styles.boxContent,
            ...{ height: collapse ? "calc(100% - 65px)" : "auto" },
          }}
        >
          <ShipmentList isBlur={isBlur} />
        </div>
        <div
          style={{
            ...styles.bottomBox,
            ...{ height: collapse ? "55px" : "350px" },
          }}
        >
          <ShipmentsStats onCollapse={this.onCollapse} />
        </div>
      </Fragment>
    );
  }
}

@inject("deliveryStore", "userStore")
@observer
class DeliveryMonitorContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { deliveryStore, userStore } = this.props;
    const { day, region } = this.props.match.params;

    // get client profiles
    userStore.getClientProfiles();

    if(!region){
      deliveryStore.regions = [];
    }

    if(!day){
      const date = new Date();
      date.setHours(0, 0, 0, 0 );
      deliveryStore.start = date.getTime() / 1000;
    }

    deliveryStore.setInlineFilter("");
    
    deliveryStore.getSettings((res) => {
      const { client_settings } = res.data;
      if (
        client_settings &&
        client_settings.settings &&
        client_settings.settings.enable_stores_filter &&
        client_settings.settings.enable_stores_filter === "true"
      ) {
        deliveryStore.setStoreFilterable(true);
      }

      if (
        client_settings &&
        client_settings.settings &&
        client_settings.settings.show_actual_dropoff_marker &&
        client_settings.settings.show_actual_dropoff_marker === "true"
      ) {
        deliveryStore.setShowActualDropoffMarker(true);
      }
    });
  }

  render() {
    const { loadingShipments } = this.props.deliveryStore;
    const { day, region, shipmentId } = this.props.match.params;
    const fullMapStyle = shipmentId ? {} : { width: "calc(100% - 400px)" };
    const { isBlur } = this.props;

    return (
      <div style={styles.container}>
        <WSShipmentModifier />
        <div style={styles.topHeader}>
          <div style={styles.topHeaderLeft}>
            <DispatchSearchFilter />
          </div>
        </div>
        <MainContainer>
          <div style={styles.mainContent} className={"momentumScrollX"}>
            <div
              style={{
                ...styles.panel,
                ...{ width: "450px", minWidth: "320px", position: "relative" },
              }}
            >
              {loadingShipments && (
                <div style={styles.overlay}>
                  <CircularProgress color="primary" size={60} style={{marginTop: 50}} />
                </div>
              )}
              <div style={{ ...Styles.box, ...styles.innerBox }}>
                <ShipmentListContainer
                  history={this.props.history}
                  isBlur={isBlur}
                />
              </div>
            </div>
          </div>
          {shipmentId && (
            <MiddlePanel>
              <div style={{ ...styles.panel }}>
                <div style={{ ...Styles.box, ...styles.innerBox }}>
                  <ShipmentDetail
                    history={this.props.history}
                    shipmentId={shipmentId}
                    isBlur={isBlur}
                  />
                </div>
              </div>
            </MiddlePanel>
          )}
          <RightPanel style={fullMapStyle}>
            <div style={{ ...styles.panel }}>
              <div style={{ ...Styles.box, ...styles.innerBox }}>
                <DeliveryMapContainer history={this.props.history} />
              </div>
            </div>
          </RightPanel>
        </MainContainer>
      </div>
    );
  }
}

export default DeliveryMonitorContainer;
